import React from "react";
import { MessageCircle, ArrowUpRight } from "lucide-react";
import { ROOMS, whatsappLink } from "../lib/constants";

export default function Rooms() {
    return (
        <section id="rooms" className="relative py-24 md:py-32 bg-cream" data-testid="rooms-section">
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
                    <div className="max-w-2xl">
                        <p className="text-xs tracking-[0.3em] uppercase text-forest-700 mb-5">Where you'll sleep</p>
                        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light text-coffee-900 leading-tight">
                            Three kinds of <span className="italic text-forest-700">quiet.</span>
                        </h2>
                    </div>
                    <p className="text-stone-600 text-base max-w-sm">
                        Every room opens onto greenery. Choose the one that fits your people.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
                    {ROOMS.map((room, i) => (
                        <article
                            key={room.id}
                            className="group flex flex-col bg-white border border-sand rounded-2xl overflow-hidden hover:-translate-y-1 hover:shadow-xl transition-all duration-500"
                            data-testid={`room-card-${room.id}`}
                        >
                            <div className="relative h-72 overflow-hidden">
                                <img
                                    src={room.image}
                                    alt={room.title}
                                    className="h-full w-full object-cover group-hover:scale-110 transition-transform duration-[1200ms]"
                                />
                                <span className="absolute top-4 left-4 bg-cream/95 text-coffee-800 px-3 py-1 text-[11px] tracking-widest uppercase rounded-full">
                                    0{i + 1}
                                </span>
                            </div>
                            <div className="p-6 md:p-8 flex flex-col flex-1">
                                <h3 className="font-serif text-3xl text-coffee-900 mb-1">{room.title}</h3>
                                <p className="text-sm uppercase tracking-widest text-forest-700 mb-5">{room.subtitle}</p>
                                <ul className="space-y-2 text-stone-600 text-sm flex-1">
                                    {room.features.map((f) => (
                                        <li key={f} className="flex items-start gap-2">
                                            <span className="mt-1 h-1.5 w-1.5 rounded-full bg-forest-700 shrink-0" />
                                            {f}
                                        </li>
                                    ))}
                                </ul>
                                <div className="mt-7 flex items-center justify-between pt-5 border-t border-sand">
                                    <span className="text-xs text-coffee-500 tracking-wide">Contact for best rates</span>
                                    <a
                                        href={whatsappLink(`Hi, I'd like to enquire about the ${room.title} at Veeras Resorts.`)}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="inline-flex items-center gap-2 text-coffee-900 text-sm font-medium group/a"
                                        data-testid={`room-enquire-${room.id}`}
                                    >
                                        <MessageCircle className="h-4 w-4" />
                                        Enquire
                                        <ArrowUpRight className="h-4 w-4 group-hover/a:translate-x-0.5 group-hover/a:-translate-y-0.5 transition-transform" />
                                    </a>
                                </div>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
